import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { MaskLines, Reveal } from "@/components/site/Reveal";
import { Footer } from "@/components/site/Footer";

export const LegalShell = ({ title, intro, testid, children }) => {
  useEffect(() => { window.scrollTo(0, 0); window.__lenis?.scrollTo(0, { immediate: true }); }, []);

  return (
    <div className="min-h-screen bg-[var(--stone)]">
      <header className="border-b border-[var(--line)]">
        <div className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-5 sm:px-8 lg:px-12">
          <Link to="/" data-testid={`${testid}-logo-link`} aria-label="Aufbruchwerk Startseite"><Logo /></Link>
          <Link to="/" data-testid={`${testid}-back-link`} className="flex items-center gap-2 text-sm text-[var(--ink-2)] transition-colors hover:text-[var(--clay)]">
            <ArrowLeft className="h-4 w-4" /> Zur Startseite
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-[1440px] px-5 py-20 sm:px-8 lg:px-12 lg:py-32" data-testid={`${testid}-page`}>
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="eyebrow">Rechtliches</p>
            <h1 className="font-serif-d mt-6 break-words text-5xl leading-[1] tracking-tight sm:text-6xl lg:text-7xl">
              <MaskLines lines={title} />
            </h1>
          </div>
          <div className="lg:col-span-8">
            <Reveal>
              <p className="max-w-2xl text-base leading-relaxed text-[var(--ink-2)] md:text-lg" data-testid={`${testid}-intro`}>{intro}</p>
            </Reveal>
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
